<section class="standard-section about" #about>
  <article class="content-wrap txt-center">
    <app-special-box [systemLogo]="true" *ngIf="sys!==undefined">
      <h2 class="margin-bottom-40">{{'about.' + sys + '.title' | translate}}</h2>
      <p *ngFor="let item of ('about.' + sys + '.paragraphs' | translate)" class="arial">
        {{item}}
      </p>
      <h3>
        {{'about.' + sys + '.guarantee.title' | translate}}
      </h3>
      <ul class="steps-list bullets-none relative flex row wrap space-around txt-center">
        <li *ngFor="let item of ('about.' + sys + '.guarantee.steps' | translate); let i = index">
          <figure class="inline-block margin-bottom-10">
            <ng-container *ngIf="i == 0">
              <figure class="secure-img"></figure>
            </ng-container>
            <ng-container *ngIf="i == 1">
              <figure class="easy-img"></figure>
            </ng-container>
            <ng-container *ngIf="i == 2">
              <figure class="winning-img"></figure>
            </ng-container>
          </figure>
          <h4>
            {{item}}
          </h4>
        </li>
      </ul>
    </app-special-box>
  </article>
  <app-fixed-box [boxShow]="showFixedBox">
    <a href="#intro" class="play-now button md relative" title="{{'PlayNow' | translate}}">
      {{'PlayNow' | translate}}
    </a>
  </app-fixed-box>
</section>
